import * as jsxRuntime from "C:\\Eidos!!!\\newvorsby\\new-vorsby-design\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment